"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_final_form_1 = require("react-final-form");
var Input_1 = __importDefault(require("react-rainbow-components/components/Input"));
var Textarea_1 = __importDefault(require("react-rainbow-components/components/Textarea"));
var Select_1 = __importDefault(require("react-rainbow-components/components/Select"));
var styled_components_1 = __importDefault(require("styled-components"));
var resolveValidation_1 = __importDefault(require("./helpers/resolveValidation"));
var getNumberValue_1 = __importDefault(require("./helpers/getNumberValue"));
var getSelectOptions_1 = __importDefault(require("./helpers/getSelectOptions"));
var fieldTypes = [
    'text',
    'password',
    'datetime',
    'datetime-local',
    'date',
    'month',
    'time',
    'week',
    'number',
    'email',
    'url',
    'search',
    'tel',
    'color',
];
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 1rem;\n"], ["\n    margin-bottom: 1rem;\n"])));
var componentsMap = {
    text: Input_1.default,
    number: Input_1.default,
    textarea: Textarea_1.default,
    select: Select_1.default,
};
var FieldsGenerator = function (props) {
    var schema = props.schema, types = props.types, validations = props.validations;
    if (Array.isArray(schema) && types) {
        return schema.map(function (field) {
            var label = field.label, name = field.name, type = field.type, required = field.required, placeholder = field.placeholder, disabled = field.disabled, readOnly = field.readOnly, min = field.min, max = field.max, maxLength = field.maxLength, minLength = field.minLength, options = field.options, defaultValue = field.default, rest = __rest(field, ["label", "name", "type", "required", "placeholder", "disabled", "readOnly", "min", "max", "maxLength", "minLength", "options", "default"]);
            var minValue = getNumberValue_1.default(min);
            var maxValue = getNumberValue_1.default(max);
            var maxLengthValue = getNumberValue_1.default(maxLength);
            var minLengthValue = getNumberValue_1.default(minLength);
            var isValidType = fieldTypes.includes(type);
            var inputType = isValidType ? type : 'text';
            var validate = resolveValidation_1.default(__assign(__assign({}, field), { minValue: minValue,
                maxValue: maxValue,
                maxLengthValue: maxLengthValue,
                minLengthValue: minLengthValue }), rest, validations);
            var isRequired = !!required;
            if (types[type]) {
                var _a = types[type], component = _a.component, componentProps = _a.props;
                var Component = component || Input_1.default;
                var typeWhenNoComponent = component ? undefined : inputType;
                return (react_1.default.createElement(Container, { key: name },
                    react_1.default.createElement(react_final_form_1.Field, __assign({}, componentProps, { component: Component, name: name, validate: validate, label: label, type: typeWhenNoComponent, required: isRequired, placeholder: placeholder, disabled: disabled, readOnly: readOnly, max: maxValue, min: minValue, maxLength: maxLengthValue, minLength: minLengthValue, defaultValue: defaultValue }))));
            }
            var DefaultComponent = componentsMap[type] || Input_1.default;
            var selectOptions = getSelectOptions_1.default(type, options);
            return (react_1.default.createElement(Container, { key: name },
                react_1.default.createElement(react_final_form_1.Field, { component: DefaultComponent, name: name, validate: validate, label: label, type: inputType, required: isRequired, placeholder: placeholder, disabled: disabled, readOnly: readOnly, max: maxValue, min: minValue, maxLength: maxLengthValue, minLength: minLengthValue, options: selectOptions, defaultValue: defaultValue })));
        });
    }
    return null;
};
var numberTypeShape = prop_types_1.default.oneOfType([
    prop_types_1.default.number,
    prop_types_1.default.shape({
        value: prop_types_1.default.number,
        errorMessage: prop_types_1.default.string,
    }),
]);
FieldsGenerator.propTypes = {
    /** An array with the fields definitions. */
    schema: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]).isRequired,
        name: prop_types_1.default.string.isRequired,
        type: prop_types_1.default.string,
        required: prop_types_1.default.oneOfType([
            prop_types_1.default.bool,
            prop_types_1.default.shape({
                errorMessage: prop_types_1.default.string,
            }),
        ]),
        placeholder: prop_types_1.default.string,
        disabled: prop_types_1.default.bool,
        readOnly: prop_types_1.default.bool,
        max: numberTypeShape,
        min: numberTypeShape,
        maxLength: numberTypeShape,
        minLength: numberTypeShape,
        options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            value: prop_types_1.default.string,
            label: prop_types_1.default.string,
        })),
        default: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    })),
    /** A map where you assign a component and its props to a field type. You can also pass custom props to the components e.g:
     * types: { tex: { component: Input, props: { className: 'my-class', ... } } }
     */
    types: prop_types_1.default.object,
    /** An object with the custom validations. e.g: { isEmail: (value) => \regex\.test(value) } */
    validations: prop_types_1.default.object,
};
FieldsGenerator.defaultProps = {
    schema: [],
    types: {},
    validations: {},
};
exports.default = FieldsGenerator;
var templateObject_1;
//# sourceMappingURL=index.js.map